import { useCallback, useMemo } from "react";
import { Dialog } from "../../../components/Dialog";

import { useStyles } from "../styles";

import {
  CampaignAwarded,
  PeopleAwardeds,
} from "../../../types/campaignAwarded";
import { useQuery } from "react-query";
import {
  findCampaignAwarded,
  listCampaignAwardeds,
} from "../../../services/campaignAwarded";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { Table } from "../../../components/Table";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Login } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

type DetailAwardedProps = {
  data: CampaignAwarded;
  open: boolean;
  onClose: () => void;
};

const emojis = {
  1: "🥇",
  2: "🥈",
  3: "🥉",
};

export function DetailAwarded({ onClose, open, data }: DetailAwardedProps) {
  const styles = useStyles();
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleNavigateToDetails = useCallback(
    (data: PeopleAwardeds) => {
      const state = {
        id_pessoa: data.person_id,
        documento: data.document,
      };
      navigate(`/people/${data.person_id}`, { state });
    },
    [navigate]
  );

  const awardeds = useQuery(
    ["awardeds", data?.id],
    () => listCampaignAwardeds(data?.id),
    { enabled: Boolean(data?.id) && Boolean(data?.processed) }
  );

  const awarded = useQuery(
    ["awarded", data?.id],
    () => findCampaignAwarded(data?.id),
    { enabled: Boolean(data?.id) }
  );

  const spublic = useMemo(() => {
    if (awarded.data?.form) {
      return "Formulários";
    } else {
      return "Audiências";
    }
  }, [awarded.data]);

  const target = useMemo(() => {
    if (awarded.data?.form) {
      return awarded.data?.form?.nome_form;
    } else {
      return awarded.data?.insight?.nome_lista;
    }
  }, [awarded.data]);

  const RenderNameAwardeds = (data: PeopleAwardeds) =>
    data.ranking > 3 ? (
      <Typography>{data.name}</Typography>
    ) : (
      <Typography>
        {emojis[data.ranking]} {data.name}
      </Typography>
    );

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      title={data?.name}
      open={open}
      onClose={handleClose}
    >
      <div className={styles.rootContent}>
        {awarded.isFetching || awardeds.isFetching ? (
          <div className={styles.rootLoading}>
            <CircularProgress size={22} thickness={4} />
          </div>
        ) : (
          <Stack spacing={2}>
            <Typography>Ação: {awarded.data?.type}</Typography>
            <Typography>Nome: {awarded.data?.name}</Typography>
            <Typography>Público: {spublic}</Typography>
            <Typography>Alvo: {target}</Typography>
            <Typography>
              Pessoas premiadas: {awarded.data?.top_ranking}
            </Typography>
            <Table
              toolbar={false}
              data={awardeds.data as []}
              columns={[
                {
                  title: "Nome",
                  field: "name",
                  render: RenderNameAwardeds,
                },
                {
                  title: "Documento",
                  field: "document",
                },
                {
                  title: "Ações",
                  align: "center",
                  render: (row) => (
                    <Tooltip title="Ver detalhes" placement="top">
                      <IconButton onClick={() => handleNavigateToDetails(row)}>
                        <Login />
                      </IconButton>
                    </Tooltip>
                  ),
                },
              ]}
              options={{
                actionsColumnIndex: -1,
                pageSize: 3,
                selectionProps: () => ({ color: "primary" }),
              }}
            />
          </Stack>
        )}
      </div>
    </Dialog>
  );
}
